module.exports = __webpack_public_path__ + "img/3.803ded96.png";